export function readStatementAccountCredit(value: unknown): number | null {
  if (value == null || typeof value !== "object") return null;
  if (!("totalAccountCredit" in value)) return null;
  const raw = (value as { totalAccountCredit?: unknown }).totalAccountCredit;
  if (raw == null || raw === "") return null;
  const amount = typeof raw === "number" ? raw : Number(raw);
  return Number.isFinite(amount) ? amount : null;
}
